import { Component, Input, ChangeDetectionStrategy, Injector, TemplateRef, QueryList, ContentChildren } from '@angular/core'
import { Store } from '@ngrx/store'
import { NavController } from 'ionic-angular'
import { UIEventHub } from '../../../services/event.service'
import { ActionCreator } from '../../../services/action.service'
import { ViewModel } from '../../../view-model'
import { BaseWidget } from '../../base-widget'
/**
 * データテーブル
 *【ヘッダー:header:any[][]】
 *【内容:records:any[]】
 *【表示先頭行:from_row_num:number】
 *【表示最大件数:max_rows:number】
 *【表示フラグ:visible:boolean】
 * @author nabla2.metamodel.generator
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-data-table',
  templateUrl: './data-table.html',
  styles: [`
    table, td, th {
      border: 1px solid #777;
    }
    td, th {
      padding: 5px;
    }
  `]
})
export class DataTable extends BaseWidget {
  /**
   * 子要素
   */
  children:TemplateRef<any>[]

  @ContentChildren(TemplateRef) templateRefs:QueryList<TemplateRef<any>>

  ngAfterContentInit() {
    this.children = this.templateRefs.toArray()
  }
  /**
   * ヘッダー
   */
  @Input() header:any[][]

  /**
   * 内容
   */
  @Input() records:any[]

  /**
   * 表示先頭行
   */
  @Input() from_row_num:number

  /**
   * 表示最大件数
   */
  @Input() max_rows:number

  /**
   * 表示フラグ
   */
  @Input() visible:boolean

  /**
   * コンストラクタ
   * @param navCtrl 画面遷移管理サービス
   * @param store Reduxストア
   */
  constructor(
    public navCtrl: NavController,
    public store: Store<{viewModel:ViewModel}>,
    public eventHub: UIEventHub,
    public actionCreator: ActionCreator,
    public injector: Injector,
  ) {
    super(injector)
  }
  /**
   * ヘッダー部構成を表す2次元配列
   */
  get headerLayout():{title:string, colSpan:number, rowSpan:number}[][] {
    const result:any[][] = []
    const header = (typeof this.header === 'string')
                 ? JSON.parse((this.header + '').replace(/'/g, '"'))
                 : this.header
    for (let i = 0, rows = header.length; i < rows; i++) {
      let row = header[i]
      let rowLayout:{title:string, colSpan:number, rowSpan:number}[] = []
      result.push(rowLayout)
      for (let j = 0, cols = row.length; j < cols; j++) {
        let col = row[j]
        if (col === null) continue
        let rowSpan = 1
        let r = i+1
        while (r < rows && header[r][j] === null) {
          r++
          rowSpan++
        }
        let colSpan = 1
        let c = j+1
        while (c < cols && row[c] === null) {
          c++
          colSpan++
        }
        rowLayout.push({
          title: col,
          colSpan: colSpan,
          rowSpan: rowSpan,
        })
      }   
    }
    return result
  }
}


// WEBPACK FOOTER //
// ./src/widgets/table/data-table/data-table.component.ts